import { registerPlugin, Capacitor } from '@capacitor/core';

const BarcodeScanFrame = registerPlugin('BarcodeScanFrame');

/**
 * ネイティブSDKが利用できる環境（Android / iOS）で、撮影からバーコードのデコードまでを一括で行う。
 *
 * @param {{ width?: number, height?: number }} options
 * @returns {Promise<{
 *   found: boolean,
 *   codemark: string|null,
 *   codedata: string|null,
 *   width: number,
 *   height: number,
 *   captureMs?: number,
 *   processMs?: number,
 *   decodeMs?: number,
 * }>}
 */
export async function captureAndDecode({ width = 1920, height = 1080 } = {}) {
  return BarcodeScanFrame.captureAndDecode({ width, height });
}

/**
 * ネイティブSDKが利用できる環境（Android / iOS）で、ネイティブのバーコード読み取りエンジンにライセンスを設定する。
 *
 * @param {string} licenseBody ライセンス発行APIから取得した本文
 * @returns {Promise<{ ret: number, success: boolean, expirationStatus: number, sdkVersion: string }>}
 */
export async function setNativeLicense(licenseBody) {
  return BarcodeScanFrame.setLicense({ licenseBody });
}

// ネイティブ側で撮影からデコードまで一括処理できるかどうかを返す（Android / iOS）
export function isNativeDecodeAvailable() {
  if (!Capacitor.isNativePlatform()) {
    return false;
  }
  const platform = Capacitor.getPlatform();
  return (platform === 'android' || platform === 'ios')
    && typeof BarcodeScanFrame.captureAndDecode === 'function';
}
